<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>

            <v-toolbar dense @click="collapse = !collapse" color="blue lighten-5">                
                <v-icon v-if="collapse">expand_more</v-icon>
                <v-icon v-if="!collapse">chevron_right</v-icon>
                <v-toolbar-title>{{mycontent.title}} (assignment)</v-toolbar-title>
            </v-toolbar>
            <v-card>
               <v-card-text>
                   <div v-if="collapse" v-html="mycontent.assignment"></div>
                </v-card-text>
            </v-card>
            
            <v-card>
                <v-toolbar dense color="blue lighten-5">
                        <v-icon @click="saveCode()" style="margin:5px;" class="material-icons-outlined">cloud_upload</v-icon>
                        <v-icon @click="readOriginalProgram()" style="margin:5px;" class="material-icons-outlined">refresh</v-icon>
                        <v-spacer></v-spacer>
                        <v-btn outlined style="margin-right:50px;">{{grade}}%</v-btn>
                        <v-icon @click="showCompileInfo = !showCompileInfo" :color="getCompilerColor()" style="margin:5px;">build</v-icon>
                        <v-icon @click="showExecuteInfo = !showExecuteInfo" :color="getResultColor()" large style="magrin-right:10px;">reorder</v-icon>
                        <v-icon @click="checkAnswer()" color="green" large style="magrin-right:5px;">check_circle_outline</v-icon>
                </v-toolbar>     
                        <div>
                            <v-tabs
                                center-active 
                                color="blue" slider-color="blue"
                                class="customTabTitle"
                                >
                                <v-tab v-for="(filename, index) in files.files" :key="index" @click="setActiveContent(index)">                                    
                                    {{filename}} &nbsp;
                                </v-tab>
                            </v-tabs>

                            <v-card v-if="vplProcessInfo>''" color="lime lighten-5">
                                <v-card-text>
                                    {{vplProcessInfo}}
                                </v-card-text>     
                            </v-card>
                            <v-card v-if="showCompileInfo" color="lime lighten-4">
                                <v-card-text>
                                    <span v-html="vplCompilerInfo"></span>
                                </v-card-text>     
                            </v-card>
                            <v-card v-if="showExecuteInfo" color="lime lighten-5">
                                <v-card-text>
                                    <span v-html="vplExecutionInfo"></span>
                                </v-card-text>     
                            </v-card>

                            <codemirror @blur="saveCode()"  class="border-top" ref="myCm1" v-model="mycontent.files[activeIndexFiles_files].rContent" 
                                            :options="getCmOptions()"
                                            >
                            </codemirror>
                            <v-card v-if="showMyAnswer">
                                <v-toolbar dense color="blue lighten-5">                        
                                    <v-toolbar-title>Authors solution:</v-toolbar-title>
                                    
                                    <v-spacer></v-spacer>
                                </v-toolbar>

 <!--                                <codemirror class="border-top" ref="myCm2" v-model="mycontent.files[activeIndexFiles_files].aContent" 
                                                :options="getCmOptions()"
                                                >
                                </codemirror>
  -->                           </v-card>
                        </div>

            </v-card>


        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from './../../axios-auth'

// import { closeSync } from 'fs';
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.js'
// language js
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/clike/clike.js'

// language hint addons
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/xml-hint.js'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/addon/hint/sql-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'

// FULL SCREEN ADDON
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'

  // merge css
import 'codemirror/addon/merge/merge.css'
  // merge js
import 'codemirror/addon/merge/merge.js'

import configData from '../../config.js'

export default {   
    data() {
        return {
                showCompileInfo: false,
                showExecuteInfo: false,
                vplProcessInfo: '',
                vplCompilerInfo: '',
                vplExecutionInfo: '',
                grade: 0,
                isRunning: false,
                task_id: 0,
                showMyAnswer: false,
                originalContent : null,

                activeIndexFiles_files : 0, // content for active tab in files
                mycontent:  {
                    title: 'loading...',
                    assignment: 'loading...',
                    files: [{
                                rContent: '',
                                aContent : ''
                            }
                    ],                     
                    testCases: '',
                    filesToKeep: [ ],
                    configFiles: [ ],
                    help: ''                    
                },
                original_files: {
                    files: ['loading...'],
                    filesToKeep: [],
                    configFiles: []
                },
                files: {
                    files: ['loading...'],
                    filesToKeep: [],
                    configFiles: []
                },                
                feedback: null,
                showMyHelp: false,
                needInit : false,
                collapse: true
        }
    },
    components :{
        codemirror
    },

    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {            
            this.needInit = false         
            this.$store.commit('setFeedback', null) 
            for(let i = 0; i < this.dcontent.data.content.files.lenght; i++) {
                this.dcontent.data.content.files[i].aContent = '';
            }
            // if (this.originalContent == null) 
            this.originalContent = JSON.stringify(this.dcontent.data.content)
            this.mycontent = (this.dcontent.data.content)   
            this.grade = this.dcontent.score

            this.task_id = this.dcontent.task_id
            this.original_files = this.dcontent.data.globals.files
            this.files = this.original_files

            axios.get('/load-program/' + this.task_id, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // set data to var
                const data = res.data.code

                if (data.length > 2) {
                    const d = JSON.parse(data)                    
                    this.files.files = []
                    this.mycontent.files = []
                    for(let i = 0; i < d.length; i++) {                       
                        this.files.files.push(d[i].filename)
                        this.mycontent.files.push( {
                             rContent:  d[i].filecontent,
                             aContent: ''
                        })
                    }
                }
            
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            // compare with myResult
            this.runCode()
            // if (questionResult < 100) 
            this.$store.commit('setTryAgainEvent',false)
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
        },
        getResultColor() {
            if (this.grade == 0 && this.vplExecutionInfo == '') return 'primary'
            if (this.grade == 0) return 'red'
            if (this.grade == 100) return 'green'
            return 'orange'
        },
        getCompilerColor() {
            if (this.vplCompilerInfo.lenght > 11) return 'red'
            if (this.vplCompilerInfo == '' && this.vplExecutionInfo == '') return 'primary'
            return 'green'
        },
        setActiveContent(index) {
            this.activeIndexFiles_files = index
        },
        runCode() {
            this.saveCode()
            if (this.isRunning) return
            this.vplProcessInfo = ''  
            this.vplCompilerInfo = ''  
            this.vplExecutionInfo = ''  
            var submitted_files = []
            var keep_files = []
            var config_files = []

            for (let i=0; i<this.files.files.length; i++) {
                submitted_files.push( {
                    filename: this.files.files[i],
                    filecontent: this.mycontent.files[i].rContent
                })
            }

            for (let i=0; i<this.files.filesToKeep.length; i++) {
                keep_files.push( {
                    filename: this.files.filesToKeep[i],
                    filecontent: this.mycontent.filesToKeep[i]
                })
            }
            for (let i=0; i<this.files.configFiles.length; i++) {
                config_files.push( {
                    filename: this.files.configFiles[i],
                    filecontent: this.mycontent.configFiles[i]
                })
            }

            let data = {
                course_id: JSON.parse(localStorage.getItem('position')).activeCourse.id,
                submitted_files: JSON.stringify(submitted_files),
                keep_files: JSON.stringify(keep_files),
                config_files: JSON.stringify(config_files),
                testCases: this.mycontent.testCases
            }

            // console.log(data)
            axios.post('/vpl-run-test', data, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // set data to var
                this.readVPLAnswer(res.data);
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        readVPLAnswer(tickets) {
            this.showCompileInfo = false
            this.showExecuteInfo = false
            
            let monitoringTarger = configData.jailSocketConnection + tickets.monitorticket+'/monitor';

            this.vplProcessInfo = 'awaiting connection... '
            this.monitoringSocket = new WebSocket(monitoringTarger);
            
            this.monitoringSocket.onopen = () => {
                    this.vplProcessInfo = "connected... ";                   
                this.monitoringSocket.onerror = ({data}) => { this.vplProcessInfo = data ; };                    
                this.monitoringSocket.onmessage = ({data}) => {
                    if (data.substring(data.length - 3) == 'seg') data = data.substring(0, data.length - 2) + '.'
                    this.vplProcessInfo = data ;

                    if (data == 'retrieve:') { // compilation successfull, start running
                            let d = { adminticket: tickets.adminticket }
                            this.vplProcessInfo = 'reading result'
                            axios.post('/vpl-get-result', d, this.$store.getters.getAxiosConfig )
                            .then((res) => {
                                // set data to var
                                this.vplCompilerInfo = '<pre>' + res.data.compilation + '</pre>'
                                this.vplExecutionInfo = '<pre>' + res.data.execution + '</pre>'
                                this.vplProcessInfo = ''
                                if (res.data.compilation >'') this.showCompileInfo = true
                                else this.showExecuteInfo = true
                                let pos = res.data.execution.indexOf('Grade :=>>')
                                if (pos>0) this.grade = res.data.execution.substring(pos+10).trim()
                                if (this.grade == '100') this.showExecuteInfo = false
                                this.$store.commit('setAnswer',this.describeAnswer('user',this.grade,''))
                                this.$store.commit('setCheckRatingEvent',true)
                            })
                            .catch(error => {
                                this.vplProcessInfo = 'error ' + error
                                this.$store.commit('setFeedback', error)
                            })
                    }
                    if (data == 'close:') { 
                        this.isRunning = false 
                        this.vplProcessInfo = ''
                    }
                }
            }
        },
        describeAnswer(user, score, lst) {
            return {
                solver: user,
                type: 6,
                answer: lst,
                answer_index: null, 
                rating: score
            }
        },
        saveCode() {
            var _d = []
            for(let i = 0; i<this.files.files.length; i++) {
                _d.push( {
                    filename: this.files.files[i],
                    filecontent: this.mycontent.files[i].rContent
                })
            }

            const data = {
                task_id : this.task_id,
                files: JSON.stringify(_d),
            }

            axios.post('/save-program', data, this.$store.getters.getAxiosConfig )
            .then(() => {
                // set data to var
                
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })

        },
        readOriginalProgram() {
            this.mycontent = JSON.parse(this.originalContent)
        },
        getCmOptions() {
            return  {
                        tabSize: 4,
                        styleActiveLine: true,
                        lineNumbers: true,
                        line: true,
                        mode: this.$store.getters.getEditorType,
                        lineWrapping: false,
                        extraKeys: {'Ctrl-Space': 'autocomplete',
                                'F11'(cm) {
                                    cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                                },
                                'Esc'(cm) {
                                if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                            }
                        }
                }
        }


    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>

</style>